import { createFeatureSelector, createSelector } from "@ngrx/store";

export const selectorProject = createSelector(
    createFeatureSelector('project'),
    (state: any) => state
);